/**
 * Horizontal rail: arrows scroll one card. Dots are removed to match the static build.
 */
export default function rail() {
    var wraps = document.querySelectorAll('[data-rail]');

    for (var i = 0; i < wraps.length; i++) {
        (function (wrap) {
            var track = wrap.querySelector('.rail');
            if (!track) { return; }

            var dots = wrap.querySelector('.raildots');
            var prev = wrap.querySelector('[data-rail-prev]');
            var next = wrap.querySelector('[data-rail-next]');
            var nav = wrap.querySelector('.railnav');
            var cards = Array.prototype.slice.call(track.children);

            if (cards.length < 2) {
                if (nav) { nav.hidden = true; }
                return;
            }

            function step() {
                return cards[1] ? cards[1].offsetLeft - cards[0].offsetLeft : cards[0].offsetWidth;
            }

            if (dots) { dots.remove(); }
            var count = wrap.querySelector('.railcount');
            if (count) { count.remove(); }

            function lastLead() {
                var max = track.scrollWidth - track.clientWidth;
                return Math.max(0, Math.min(cards.length - 1, Math.round(max / Math.max(1, step()))));
            }

            function lead() {
                return Math.min(lastLead(), Math.round(track.scrollLeft / Math.max(1, step())));
            }

            var raf;
            var snapTimer;
            var reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;

            function goTo(index) {
                var card = cards[Math.max(0, Math.min(cards.length - 1, index))];
                var to = card.offsetLeft - cards[0].offsetLeft;
                var from = track.scrollLeft;
                if (Math.abs(to - from) < 1) { return; }

                cancelAnimationFrame(raf);
                clearTimeout(snapTimer);
                track.style.scrollSnapType = 'none';
                track.style.scrollBehavior = 'auto';

                function land() {
                    snapTimer = setTimeout(function () {
                        track.style.scrollSnapType = '';
                        track.style.scrollBehavior = '';
                        sync();
                    }, 60);
                }

                if (reduce) {
                    track.scrollLeft = to;
                    sync();
                    land();
                    return;
                }

                var start = performance.now();
                var duration = 420;
                function ease(p) {
                    return p < 0.5 ? 4 * p * p * p : 1 - Math.pow(-2 * p + 2, 3) / 2;
                }
                function tick(now) {
                    var p = Math.min(1, (now - start) / duration);
                    track.scrollLeft = from + (to - from) * ease(p);
                    if (p < 1) { raf = requestAnimationFrame(tick); }
                    else {
                        track.scrollLeft = to;
                        sync();
                        land();
                    }
                }
                raf = requestAnimationFrame(tick);
                sync();
            }

            if (prev) {
                prev.addEventListener('click', function () {
                    goTo(lead() - 1);
                });
            }
            if (next) {
                next.addEventListener('click', function () {
                    goTo(lead() + 1);
                });
            }

            function sync() {
                var max = track.scrollWidth - track.clientWidth;
                if (nav) { nav.hidden = max < 4; }
                var at = lead();
                if (prev) { prev.disabled = at <= 0; }
                if (next) { next.disabled = at >= lastLead() || track.scrollLeft > max - 4; }
            }

            var timer;
            track.addEventListener(
                'scroll',
                function () {
                    clearTimeout(timer);
                    timer = setTimeout(sync, 60);
                },
                { passive: true }
            );
            addEventListener('resize', sync);
            sync();
        })(wraps[i]);
    }
}
